export interface SaldoPromocionesItem {
    descripcion: string;
    descripcionTotal: string;
    fechaMaximaCanjeo: string;
    idPromo: number;
    saldo: number;
    saldoUtilizar: number;
    aplicado: boolean;
}

export class SaldoPromocionesHelper {
    static mock() {
        return [
            {
                descripcion: 'Promo 1',
                descripcionTotal: 'Desc total promo 1',
                fechaMaximaCanjeo: null,
                idPromo: 1,
                saldo: 50,
                saldoUtilizar: null,
                aplicado: false,
            },
            {
                descripcion: 'Promo 2',
                descripcionTotal: 'Desc total promo 2',
                fechaMaximaCanjeo: null,
                idPromo: 2,
                saldo: 100,
                saldoUtilizar: null,
                aplicado: false,
            },
        ];
    }
    static fromAPI(items): SaldoPromocionesItem[] {
        return items.map((i) => {
            return {
                descripcion: i.DESCRIPCION || null,
                descripcionTotal: i.DESCRIPCION_TOTAL || null,
                fechaMaximaCanjeo: i.FECHAMAXIMOCANJEO || null,
                idPromo: i.IDPROMO || null,
                saldo: i.SALDO || 0,
                saldoUtilizar: 0,
                aplicado: false,
            };
        });
    }
    static toAPI(items: SaldoPromocionesItem[]): string {
        const itemsToApi = items
            .map((i) => {
                return i.saldoUtilizar > 0 ? 'IDPROMO=>' + i.idPromo + '&&IMPORTE=>' + i.saldoUtilizar : null;
            })
            .filter((i) => i !== null);
        return itemsToApi.length ? btoa(itemsToApi.join('##')) : null;
    }
}
